var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: _vm.uploadUrl + "?name=test",
        "list-type": "picture-card",
        multiple: "",
        headers: _vm.headers,
        "file-list": _vm.fileList,
        "on-success": _vm.handleSuccess,
        "auto-upload": true,
      },
      scopedSlots: _vm._u([
        {
          key: "file",
          fn: function (ref) {
            var file = ref.file
            return _c("div", {}, [
              _c("img", {
                staticClass: "el-upload-list__item-thumbnail",
                attrs: { src: file.url, alt: "" },
              }),
            ])
          },
        },
      ]),
    },
    [
      _c("i", {
        staticClass: "el-icon-plus",
        attrs: { slot: "default" },
        slot: "default",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }